export default __webpack_public_path__ + "static/media/ica.8d264d72.png";